import React from 'react';
import styled from 'styled-components';
import { Home, Favorite, ShoppingCart, Person } from '@mui/icons-material';
import { colors, borderRadius, shadows, spacing, typography } from '../styles/theme';

const Navigation = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${colors.backgroundSecondary};
  border-top: 1px solid ${colors.borderLight};
  box-shadow: ${shadows.lg};
  padding: ${spacing.sm} 0;
  z-index: 100;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
`;

const NavContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  max-width: 480px;
  margin: 0 auto;
`;

const NavItem = styled.button<{ isActive: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing.xs};
  padding: ${spacing.sm};
  border: none;
  background: none;
  cursor: pointer;
  border-radius: ${borderRadius.md};
  transition: all 0.2s ease;
  min-width: 60px;

  color: ${props => props.isActive ? colors.primary : colors.textTertiary};

  &:active {
    background: ${colors.backgroundTertiary};
    transform: scale(0.95);
  }

  &:hover {
    color: ${colors.primary};
  }
`;

const Icon = styled.div`
  font-size: 20px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Label = styled.span`
  font-family: ${typography.fontFamily};
  font-size: ${typography.fontSize.xs};
  font-weight: ${typography.fontWeight.medium};
  line-height: 1;
`;

interface BottomNavigationProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  cartItemsCount?: number;
}

const BottomNavigation: React.FC<BottomNavigationProps> = ({
  activeTab,
  onTabChange,
  cartItemsCount = 0
}) => {
  const navItems = [
    { id: 'home', label: 'Главная', icon: <Home /> },
    { id: 'favorites', label: 'Избранное', icon: <Favorite /> },
    { id: 'profile', label: 'Профиль', icon: <Person /> },
    { id: 'cart', label: 'Корзина', icon: <ShoppingCart />, badge: cartItemsCount },
  ];

  return (
    <Navigation>
      <NavContainer>
        {navItems.map((item) => (
          <NavItem
            key={item.id}
            isActive={activeTab === item.id}
            onClick={() => onTabChange(item.id)}
          >
            <Icon>
              {item.badge && item.badge > 0 ? (
                <span style={{ position: 'relative' }}>
                  {item.icon}
                  <Badge>{item.badge}</Badge>
                </span>
              ) : (
                item.icon
              )}
            </Icon>
            <Label>{item.label}</Label>
          </NavItem>
        ))}
      </NavContainer>
    </Navigation>
  );
};

const Badge = styled.span`
  position: absolute;
  top: -8px;
  right: -8px;
  background: ${colors.error};
  color: ${colors.textInverse};
  border-radius: ${borderRadius.full};
  width: 18px;
  height: 18px;
  font-size: ${typography.fontSize.xs};
  font-weight: ${typography.fontWeight.bold};
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
`;

export default BottomNavigation;
